import { render, staticRenderFns } from "./PriceLimits.vue?vue&type=template&id=ea4d803c&scoped=true"
import script from "./PriceLimits.vue?vue&type=script&lang=js"
export * from "./PriceLimits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4d803c",
  null
  
)

export default component.exports